import { createRoot } from 'react-dom/client'
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/css/public-ui.css'
import { AppRoutes } from './app/routing/AppRoutes'
import setupAxios from './app/axios/axiosSettings'
import { Provider } from 'react-redux'
import { store } from './app/redux/store'
import { setupDeploymentUpdates, setupStaleChunkRecovery } from './app/utils/deploymentVersion'
import { subscribeToLogout } from './app/axios/authSession'
import { logoutFromAnotherTab } from './app/redux/auth/authSlice'

setupAxios()
const stopDeploymentUpdates = setupDeploymentUpdates()
const stopStaleChunkRecovery = setupStaleChunkRecovery()
const stopSessionSync = subscribeToLogout(() => store.dispatch(logoutFromAnotherTab()))

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    stopDeploymentUpdates()
    stopStaleChunkRecovery()
    stopSessionSync()
  })
}

const storedTheme = localStorage.getItem('kt_theme_mode_value')
const theme = storedTheme && storedTheme !== 'system'
  ? storedTheme
  : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
document.documentElement.setAttribute('data-bs-theme', theme)

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <MetronicI18nProvider>
        <AppRoutes />
      </MetronicI18nProvider>
    </Provider>
  )
}
